const SOUTH_KEYS = [
  ["7", "Hồ Chí Minh"],
  ["8", "Đồng Tháp"],
  ["9", "Cà Mau"],
  ["10", "Bến Tre"],
  ["11", "Vũng Tàu"],
  ["12", "Bạc Liêu"],
  ["13", "Đồng Nai"],
  ["14", "Cần Thơ"],
  ["15", "Sóc Trăng"],
  ["16", "Tây Ninh"],
  ["17", "An Giang"],
  ["18", "Bình Thuận"],
  ["19", "Vĩnh Long"],
  ["20", "Bình Dương"],
  ["21", "Trà Vinh"],
  ["22", "Long An"],
  ["23", "Bình Phước"],
  ["24", "Hậu Giang"],
  ["25", "Tiền Giang"],
  ["26", "Kiên Giang"],
  ["27", "Đà Lạt"],
];

const CENTRAL_KEYS = [
  ["28", "Phú Yên"],
  ["29", "Thừa Thiên Huế"],
  ["30", "Đắk Lắk"],
  ["31", "Quảng Nam"],
  ["32", "Đà Nẵng"],
  ["33", "Khánh Hòa"],
  ["34", "Quảng Bình"],
  ["35", "Bình Định"],
  ["36", "Quảng Trị"],
  ["37", "Gia Lai"],
  ["38", "Ninh Thuận"],
  ["39", "Quảng Ngãi"],
  ["40", "Đắk Nông"],
  ["41", "Kon Tum"],
];

export const LOTTERIES = [
  { key: "1", name: "Miền Bắc", kind: "region", region: "mb" },
  { key: "5", name: "Miền Trung", kind: "region", region: "mt" },
  { key: "6", name: "Miền Nam", kind: "region", region: "mn" },
  ...SOUTH_KEYS.map(([key, name]) => ({ key, name, kind: "province", region: "mn" })),
  ...CENTRAL_KEYS.map(([key, name]) => ({ key, name, kind: "province", region: "mt" })),
  { key: "42", name: "Mega 6/45", kind: "vietlott" },
  { key: "43", name: "Max 4D", kind: "vietlott" },
  { key: "44", name: "Power 6/55", kind: "vietlott" },
  { key: "45", name: "Max 3D", kind: "vietlott" },
  { key: "vietlott", name: "Vietlott", kind: "vietlott" },
];

export function regionCaption(name, draw) {
  return `Xổ số ${name} ${draw.weekdayLong} ${draw.dash}`;
}

export function provinceCaption(name, draw) {
  return `Kết quả Xổ số ${name} ${draw.weekdayLong} ${draw.dash}`;
}

export function summaryTitle(name, draw) {
  return `Tóm tắt kết quả Xổ số ${name} ${draw.weekdayShort} (${draw.slash}):`;
}

export function lotoCaption(name, draw) {
  return `Lô tô ${name} ${draw.weekdayLong} ${draw.dash}`;
}

export function lotoOf(stationItem) {
  const prizes = stationItem.prizes;
  const order = ["g8", "g7", "g6", "g5", "g4", "g3", "g2", "g1", "db"];
  const nums = [];
  order.forEach((key) => {
    (prizes[key] || []).forEach((value) => nums.push(String(value).slice(-2)));
  });
  nums.sort();
  const tail = String(prizes.db?.[0] || "").slice(-2);
  const flags = nums.map(() => false);
  for (let i = nums.length - 1; i >= 0; i -= 1) {
    if (nums[i] === tail) {
      flags[i] = true;
      break;
    }
  }
  const dau = Array.from({ length: 10 }, (_, digit) => nums.filter((n) => n[0] === String(digit)));
  const duoi = Array.from({ length: 10 }, (_, digit) => nums.filter((n) => n[1] === String(digit)));
  return { nums, flags, dau, duoi };
}

export function fmtGroup(list) {
  if (!list.length) return "-";
  return ` ${list.map((n) => `${n};`).join(" ")} `;
}

export const MB_ROWS = [
  ["db", "Đặc biệt", "1"],
  ["g1", "Giải nhất", "2"],
  ["g2", "Giải nhì", "3"],
  ["g3", "Giải ba", "4"],
  ["g4", "Giải tư", "5"],
  ["g5", "Giải năm", "6"],
  ["g6", "Giải sáu", "7"],
  ["g7", "Giải bảy", "8"],
];

export const SOUTH_HOME = [
  ["g8", "Giải tám", "9"],
  ["g7", "Giải bảy", "8"],
  ["g6", "Giải sáu", "7"],
  ["g5", "Giải năm", "6"],
  ["g4", "Giải tư", "5"],
  ["g3", "Giải ba", "4"],
  ["g2", "Giải nhì", "3"],
  ["g1", "Giải nhất", "2"],
  ["db", "Đặc biệt", "1"],
];

export const SOUTH_PROVINCE = [
  ["db", "Đặc biệt", "1"],
  ["g1", "Giải nhất", "2"],
  ["g2", "Giải nhì", "3"],
  ["g3", "Giải ba", "4"],
  ["g4", "Giải tư", "5"],
  ["g5", "Giải năm", "6"],
  ["g6", "Giải sáu", "7"],
  ["g7", "Giải bảy", "8"],
  ["g8", "Giải tám", "9"],
];

export function zipStations(stations, key) {
  const lists = stations.map((item) => item.prizes[key] || []);
  const max = Math.max(0, ...lists.map((list) => list.length));
  const out = [];
  for (let row = 0; row < max; row += 1) {
    lists.forEach((list) => {
      if (list[row] != null) out.push(list[row]);
    });
  }
  return out;
}
